import React, { useContext, useReducer } from "react";
import { CircularProgress, Grid, Typography } from "@mui/material";
import { StoreContext } from "../../StoreContext";
import { observer } from "mobx-react";
import { ColDataType } from "../../dto";
import Table from "./Table";
import { toJS } from "mobx";
import { ProcessState } from "../../stores/models";
import styled from "@emotion/styled";
import { ToggleButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import FilterWidget from "../FilterWidget";
const Styled_TableContainer = styled("div")(({ theme }) => ({
    width: "100%",
    height: "100%",
}));
const fKDialogReducer = (state, action) => {
    return { open: action.open, fkRef: action.fkRef, row: action.row, colKey: action.colKey };
};
const stateDialogReducer = (state, action) => {
    return { code: action.code, colKey: action.colKey, anchorId: action.anchorId, open: action.open };
};
const DatasetWidget = observer(() => {
    const context = useContext(StoreContext);
    const [t, i18n] = useTranslation();
    let dataStore = context.rootStore.dataStore;
    const initialStateDialogState = { open: false, colKey: "", code: 0, anchorId: "" };
    const [stateDialogState, dispatchStateDialog] = useReducer(stateDialogReducer, initialStateDialogState);
    const initialFKDialogState = { open: false, fkRef: null, row: {}, colKey: "" };
    const [fKDialogState, dispatchFKDialog] = useReducer(fKDialogReducer, initialFKDialogState);
    const onStateActionClicked = (colKey, code, anchorId) => {
        if (stateDialogState.open) {
            if (stateDialogState.anchorId != anchorId) {
                dispatchStateDialog({ open: true, colKey: colKey, code: code, anchorId: anchorId });
            }
            else {
                dispatchStateDialog({ open: false, colKey: "", code: 0, anchorId: "" });
            }
        }
        else {
            dispatchStateDialog({ open: true, colKey: colKey, code: code, anchorId: anchorId });
        }
    };
    const onFKActionClicked = (colKey, row) => {
        if (fKDialogState.open) {
            dispatchFKDialog({ open: false, fkRef: null, row: {}, colKey: "" });
        }
        else {
            let columns = dataStore.tableModel.columns.filter((col) => col.label == colKey);
            if (columns.length > 0) {
                dispatchFKDialog({ open: true, fkRef: columns[0].foreignKey, row: row, colKey: colKey });
            }
        }
    };
    const getCellRenderer = (column) => {
        if (column.foreignKey) {
            return "foreignKeyCellRenderer";
        }
        else if (column.dataType.label == ColDataType.boolean) {
            return "booleanCellRenderer";
        }
        else if (column.dataType.label == ColDataType.float || column.dataType.label == ColDataType.decimal) {
            return "floatCellRenderer";
        }
        return "defaultCellRenderer";
    };
    const getCellEditor = (dataType) => {
        if (dataType == ColDataType.float || dataType == ColDataType.integer || dataType == ColDataType.decimal) {
            return "numberCellEditor";
        }
        return "agTextCellEditor";
    };
    const computeColums = () => {
        return dataStore.tableModel.columns.map((col) => {
            return {
                headerName: col.label,
                field: col.label,
                editable: !col.isPrimaryKey && false, // due to perfomance issues currently set to false
                cellRenderer: getCellRenderer(col),
                cellEditor: getCellEditor(col.dataType.label),
                cellRendererParams: {
                    onStateActionClicked: onStateActionClicked,
                    onFKActionClicked: onFKActionClicked,
                },
                headerComponentParams: {
                    isPrimaryKey: col.isPrimaryKey,
                },
                hide: !col.isInTargetModel, // currently hide all columns which are not part of target model
            };
        });
    };
    const onRowEdited = (event) => {
        dataStore.updataData(event.data, event.colDef.field, event.newValue);
    };
    const getData = () => {
        // toJS necessary to improve performance
        let data = toJS(dataStore.data);
        if (dataStore.currentLoadingProcessId != null || dataStore.dataStockFilled) {
            let firstColumn = dataStore.tableModel.columns[0];
            if (firstColumn) {
                let loadingRow = {};
                loadingRow[firstColumn.label] = "Lädt...";
                data.push(loadingRow);
            }
        }
        return data;
    };
    return (React.createElement(Grid, { container: true, direction: "column", spacing: 1 },
        React.createElement(Grid, { item: true, container: true, spacing: 1 },
            React.createElement(Grid, { item: true },
                React.createElement(ToggleButton, { style: { padding: "5px" }, value: "showRows", selected: dataStore.showRowsWithFailure, onClick: () => dataStore.setShowRowsWithFailure(!dataStore.showRowsWithFailure) },
                    React.createElement(Typography, { variant: "body2" }, t("translations:filter rows with failure")))),
            React.createElement(Grid, { item: true },
                React.createElement(FilterWidget, null))),
        React.createElement(Grid, { item: true },
            React.createElement(Styled_TableContainer, { className: "zeb-tabulator" },
                dataStore.dataState == ProcessState.LOADING && (React.createElement("div", { style: { height: "20rem", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" } },
                    React.createElement(CircularProgress, null))),
                dataStore.dataState == ProcessState.SUCCESS && (React.createElement(Table, { onRowUpdated: onRowEdited, columns: computeColums(), data: getData(), requestData: () => {
                        dataStore.requestDataStock();
                    } })),
                dataStore.dataState == ProcessState.ERROR && React.createElement("span", null, "Ein Fehler ist aufgetreten")))));
});
export default DatasetWidget;
